import { unset, set, when } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'
import logout from '../actions/logout'
import closeNavigation from './closeNavigation'
import resetAllForms from '../factories/resetAllForms'
import isPreventAllClientFields from '../factories/isPreventAllClientFields'
import makeFieldRequired from '../factories/makeFieldRequired'
import isRemoteLogin from '../../client/actions/isRemoteLogin'
import resetSelectedOptions from '../actions/resetSelectedOptions'
import initializeFields from 'modules/app/chains/initializeFields'

export default [
  when('state:client.user.useSSO'),{
    true: [
      function({state, services}){
        services.Http
          .post('/api/user/logout', {})
          .then(() => window.location.href = state.get('client.sso.thirdPartyLogoutURL'))
      }
    ],
    false: [
      unset('client.user'),
      unset('client.currentUser'),
      unset('users'),
      unset('client.helper'),
      set('state:login.acceptedGDPR', false),
      ...initializeFields,
      isPreventAllClientFields(true),
      isRemoteLogin,
      {
        true: [],
        false: [
          makeFieldRequired(
            'client.registrating.current.newPassword.password',
            true
          ),
          makeFieldRequired(
            'client.registrating.current.newPassword.confirmPassword',
            true
          )
        ]
      },
      resetAllForms(),
      resetSelectedOptions,
      logout,
      {
        success: [],
        error: []
      },
      ...closeNavigation,
      redirect('/login')
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/logout.js